import { Component, OnInit } from '@angular/core';
import { MessageService } from '../../services/email.service';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 's18-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {
  email: string;

  constructor(
    private messageService: MessageService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit() {
  }

  sendEmail(){
    this.messageService.contactEmail(this.email)
      .subscribe( resp => {
        let response = JSON.parse(resp.d).response;
        if ( response === 'Accepted'){
          this.snackBar.open("Email sent! Someone will contact you shortly", null, { duration: 3000 });
        }else{
          this.snackBar.open("We were not able to send the email.  Please try again later.", null, { panelClass: 'warning-toast', duration: 3000, verticalPosition: 'top', horizontalPosition: 'right' });
        }
      });
  }

}
